import { LotteryModuleResult, ModulePreference } from '@thro-types/modules-selections';

import { AxiosError, AxiosRequestConfig } from 'axios';
import { Gateway } from 'index';

export declare class CalculatedLotteryResult {
  id: number;
  createdAt: Date;
  modules: ModuleLotteryResult[];
}
export declare class ModuleLotteryResult {
  moduleId: number;
  assigned: ModuleLotteryResultStudentInfo[];
  waitlist: ModuleLotteryResultStudentInfo[];
}
export declare class ModuleLotteryResultStudentInfo {
  userId: number;
  drawnNumber: number;
  courseOfStudyId: number;
  uniqueCode?: string;
  firstName: string;
  modulePreferences?: ModulePreference[];
  semester?: string;
  lastName: string;
  email: string;
  signedOut?: boolean;
  receivedDesiredNumberOfModules?: boolean;
}

export const getLotteryResults = async (
  moduleId: number,
  config?: AxiosRequestConfig
): Promise<LotteryModuleResult> => {
  try {
    const response = await Gateway.get<LotteryModuleResult>(`/lottery-results/${moduleId}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getLatestCalculatedLotteryResults = async (
  config?: AxiosRequestConfig
): Promise<CalculatedLotteryResult> => {
  try {
    const response = await Gateway.get(`/lottery-results/latest`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};
